var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VAppBar',{staticClass:"appbar",attrs:{"height":"96","flat":""}},[_c('VContainer',{staticClass:"d-flex flex-nowrap fill-height",class:{ 'justify-center': _vm.isMobile }},[_c('TheBrand')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }